// Libs
import { call, take, put, fork } from 'redux-saga/effects'
import _get from 'lodash/get'

// Constants
import {
  SUBMIT_CHANGES_TO_SPATIAL,
} from './../constants'

// Controller
import spatialCtrl from 'fc-ctrl-spatials'

// Operator
import { featureOperator } from 'hfty-map'

export default function *watchChangesToSpatial () {
  while (true) {
    const { payload } = yield take(SUBMIT_CHANGES_TO_SPATIAL)
    yield fork(handleSubmitChangesToSpatial, payload)
  }
}

export function *handleSubmitChangesToSpatial (operation) {
  const newShape = _get(operation, 'model.shape', null)
  const shapeId = newShape.id

  const METHOD = shapeId ? 'update' : 'create'
  const { error: spatialError } = yield call(spatialCtrl[METHOD], {
    id: shapeId,
    model: newShape,
  })

  if (spatialError) {
    yield put(featureOperator.actionCreators.updateOperation({
      ...operation,
      submitting: false,
      success: false,
      error: spatialError,
    }))
  } else {
    const successOp = {
      ...operation,
      submitting: false,
      success: true,
      error: [],
    }
    yield put(featureOperator.actionCreators.submitOperation(successOp))
  }
  return !spatialError
}
